"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchitectSDK = void 0;
var http_1 = require("./http");
var auth_1 = require("./auth");
var token_1 = require("./auth/token");
var files_1 = require("./files");
var resources_1 = require("./resources");
var const_1 = require("../const");
var ArchitectSDK = /** @class */ (function () {
    function ArchitectSDK(config) {
        var baseUrl = config.baseUrl, _a = config.recommendedCase, recommendedCase = _a === void 0 ? true : _a;
        var tokenManager = token_1.TokenManager.getInstance(const_1.LOCAL_STORAGE_KEYS.AUTH_TOKEN, const_1.LOCAL_STORAGE_KEYS.USER_ID_TOKEN);
        this.httpClient = new http_1.HttpClient((new URL(baseUrl)).origin, tokenManager, recommendedCase);
        this.resourceServices = {
            users: new resources_1.UsersService(this.httpClient),
        };
        this.authService = new auth_1.AuthService(this.httpClient, tokenManager);
        this.filesService = new files_1.FilesService(this.httpClient, tokenManager);
    }
    ArchitectSDK.getInstance = function (config) {
        if (!ArchitectSDK.instance) {
            ArchitectSDK.instance = new ArchitectSDK(config);
        }
        return ArchitectSDK.instance;
    };
    ArchitectSDK.prototype.resource = function (resourceName) {
        if (!this.resourceServices[resourceName]) {
            this.resourceServices[resourceName] = new resources_1.ResourceService(resourceName, this.httpClient);
        }
        return this.resourceServices[resourceName];
    };
    ArchitectSDK.prototype.auth = function () {
        return this.authService;
    };
    ArchitectSDK.prototype.files = function () {
        return this.filesService;
    };
    return ArchitectSDK;
}());
exports.ArchitectSDK = ArchitectSDK;
